export default __webpack_public_path__ + "static/media/16.9f8428ae.jpg";